export default __webpack_public_path__ + "static/media/sharpPelvicPain.295e37db.png";